<template>
  <div v-if="Object.keys(trip_data).length > 0">
    <b-modal
      id="explore-trip-info-modal"
      ref="explore-trip-info-modal-ref"
      hide-footer
      title="Trip Information"
    >
      <div
        v-if="trip_data.images.length > 0"
        class="modal-banner-container"
      >
        <img
          :src="trip_data.images[0].href"
          class="vtd-center-image"
        >
        <div class="modal-banner-text">
          {{ trip_data.product.name }}
        </div>
      </div>
      <div>
        <h4 class="mt-3 orange">
          Introduction
        </h4>
        <p
          class="text-left"
          v-html="trip_data.product.introduction"
        />
      </div>
      <div class="row">
        <div
          v-if="trip_data.product.countries.length > 1"
          class="col-md-4 vtd-font-weight-bold"
        >
          Countries:
        </div>
        <div
          v-if="trip_data.product.countries.length === 1"
          class="col-md-4 vtd-font-weight-bold"
        >
          Country:
        </div>
        <div class="col-md-8">
          <span
            v-for="(country, index) in trip_data.product.countries"
            :key="index"
          >{{ country
          }}<span
            v-if="index !== trip_data.product.countries.length - 1"
          >,
          </span></span>
        </div>
      </div>
      <div
        v-if="trip_data.product.start_city"
        class="row"
      >
        <div class="col-md-4 vtd-font-weight-bold">
          Start City:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.start_city }}
        </div>
      </div>
      <div
        v-if="trip_data.product.finish_city"
        class="row"
      >
        <div class="col-md-4 vtd-font-weight-bold">
          End City:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.finish_city }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Duration:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.duration }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Trip Style:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.trip_style }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Theme:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.theme }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Trip Code:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.code }}
        </div>
      </div>
      <div
        v-if="trip_data.product.physical_rating"
        class="row"
      >
        <div class="col-md-4 vtd-font-weight-bold">
          Physical Rating:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.physical_rating }}
        </div>
      </div>
      <div
        v-if="trip_data.product.trek_rating"
        class="row"
      >
        <div class="col-md-4 vtd-font-weight-bold">
          Trek Rating:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.trek_rating }}
        </div>
      </div>
      <div
        v-if="trip_data.product.cycling_rating"
        class="row"
      >
        <div class="col-md-4 vtd-font-weight-bold">
          Cycling Rating:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.cycling_rating }}
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Meals Included:
        </div>
        <div class="col-md-8">
          <span v-if="trip_data.product.breakfast">
            {{ trip_data.product.breakfast }}</span>
          <span
            v-if="
              (trip_data.product.breakfast && trip_data.product.lunch) ||
                (trip_data.product.breakfast && trip_data.product.dinner)
            "
          >,
          </span>
          <span v-if="trip_data.product.lunch">
            {{ trip_data.product.lunch }}</span>
          <span
            v-if="trip_data.product.lunch && trip_data.product.dinner"
          >,
          </span>
          <span v-if="trip_data.product.dinner">
            {{ trip_data.product.dinner }}
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Transport:
        </div>
        <div class="col-md-8">
          <span
            v-for="(transport, index) in trip_data.product.transport"
            :key="index"
          >{{ transport
          }}<span
            v-if="index !== trip_data.product.transport.length - 1"
          >,
          </span></span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 vtd-font-weight-bold">
          Minimum Age:
        </div>
        <div class="col-md-8">
          {{ trip_data.product.min_age }}
        </div>
      </div>
      <div>
        <h4 class="mt-3 orange">
          Trip Map
        </h4>
        <img
          :src="trip_data.product.map_image"
          class="vtd-center-image"
        >
      </div>
      <div
        v-if="
          trip_data.trip_notes.join_town ||
            trip_data.trip_notes.join_place ||
            trip_data.trip_notes.join_time
        "
      >
        <h4 class="mt-3 orange">
          Joining the Trip
        </h4>
        <div
          v-if="trip_data.trip_notes.join_town"
          class="row"
        >
          <div class="col-md-4 vtd-font-weight-bold">
            City:
          </div>
          <div class="col-md-8">
            {{ trip_data.trip_notes.join_town }}
          </div>
        </div>
        <div
          v-if="trip_data.trip_notes.join_place"
          class="row"
        >
          <div class="col-md-4 vtd-font-weight-bold">
            Place:
          </div>
          <div class="col-md-8">
            {{ trip_data.trip_notes.join_place }}
          </div>
        </div>
        <div
          v-if="trip_data.trip_notes.join_time"
          class="row"
        >
          <div class="col-md-4 vtd-font-weight-bold">
            Time:
          </div>
          <div class="col-md-8">
            {{ trip_data.trip_notes.join_time }}
          </div>
        </div>
      </div>
      <h4 class="mt-3 orange">
        Itinerary
      </h4>
      <div
        v-for="obj in trip_data.itinerary"
        :key="obj.day"
        class="itinerary-container"
      >
        <h6 class="orange">
          Day {{ obj.day }}
        </h6>
        <p>
          <strong> {{ obj.short_description }}. </strong>
        </p>
        <p>{{ obj.full_description }}</p>
        <div
          v-if="obj.accommodation_type"
          class="inclusion-container"
        >
          <h5 class="vtd-font-weight-bold">
            Accommodation Type:
          </h5>
          <p>{{ obj.accommodation_type }}</p>
        </div>
        <div
          v-if="obj.accommodation_name"
          class="inclusion-container"
        >
          <h5 class="vtd-font-weight-bold">
            Accommodation Name:
          </h5>
          <p>{{ obj.accommodation_name }}</p>
        </div>
        <div
          v-if="obj.meals.length > 0"
          class="inclusion-container"
        >
          <h5
            v-if="obj.meals.length === 1"
            class="vtd-font-weight-bold"
          >
            Meal:
          </h5>
          <h5
            v-if="obj.meals.length > 1"
            class="vtd-font-weight-bold"
          >
            Meals:
          </h5>
          <span
            v-for="(meal, index) in obj.meals"
            :key="index"
          >{{ meal
          }}<span v-if="index !== obj.meals.length - 1">, </span></span>
        </div>
      </div>
      <div
        v-if="trip_data.trip_notes.end_town || trip_data.trip_notes.end_time"
      >
        <h4 class="mt-3 orange">
          Finishing the Trip
        </h4>
        <div
          v-if="trip_data.trip_notes.end_town"
          class="row"
        >
          <div class="col-md-4 vtd-font-weight-bold">
            City:
          </div>
          <div class="col-md-8">
            {{ trip_data.trip_notes.end_town }}
          </div>
        </div>
        <div
          v-if="trip_data.trip_notes.end_time"
          class="row"
        >
          <div class="col-md-4 vtd-font-weight-bold">
            Time:
          </div>
          <div class="col-md-8">
            {{ trip_data.trip_notes.end_time }}
          </div>
        </div>
      </div>
      <template>
        <div>
          <h4 class="mt-3 orange">
            Gallery
          </h4>
          <b-carousel
            id="carousel-1"
            v-model="slide"
            :interval="4000"
            controls
            indicators
            background="#ffffff"
            img-width="1024"
            img-height="480"
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
          >
            <div
              v-for="(image, index) in trip_data.images"
              :key="index"
            >
              <b-carousel-slide
                v-if="index !== 0"
                :img-src="image.href"
                class="image-size"
              />
            </div>
          </b-carousel>
        </div>
      </template>
      <div>
        <h4 class="mt-3 orange">
          Trip Notes
        </h4>
        <div v-if="trip_data.trip_notes.visas">
          <h5 class="mt-3 vtd-font-weight-bold">
            Visas
          </h5>
          <p v-html="trip_data.trip_notes.visas" />
        </div>
        <div>
          <h5 class="mt-3 vtd-font-weight-bold">
            Vaccinations
          </h5>
          <div
            v-for="(advice, index) in trip_data.trip_notes.health"
            :key="index"
            class="row"
          >
            <div
              class="mt-3 col-md-2"
              v-html="advice.country + ':'"
            />
            <div
              class="mt-3 col-md-10"
              v-html="advice.vaccination"
            />
          </div>
        </div>
        <div>
          <h5 class="mt-3 vtd-font-weight-bold">
            Money
          </h5>
          <div
            v-for="(advice, index) in trip_data.trip_notes.money"
            :key="index"
            class="row"
          >
            <div
              class="mt-3 col-md-2"
              v-html="advice.country + ':'"
            />
            <div
              class="mt-3 col-md-10"
              v-html="advice.currency"
            />
          </div>
        </div>
        <div>
          <h5 class="mt-3 vtd-font-weight-bold">
            Climate
          </h5>
          <div
            v-for="(advice, index) in trip_data.trip_notes.climate"
            :key="index"
            class="row"
          >
            <div
              class="mt-3 col-md-2"
              v-html="advice.country + ':'"
            />
            <div
              class="mt-3 col-md-10"
              v-html="advice.climate"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>

export default {
  props: {
    trip_data: {},
    item: null
  },
  data() {
    return {
      slide: 0,
      sliding: null,
    };
  },
  computed: {
    returnDays() {
      if (
        this.trip_data &&
        this.trip_data.itinerary &&
        Array.isArray(this.trip_data.itinerary)
      ) {
        return this.trip_data.itinerary.length;
      }
      return "";
    },
  },
  methods: {
    show(htlpagelink) {
      this.$refs["explore-trip-info-modal-ref"].show();
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>
<style scoped>
.modal-banner-container {
  position: relative;
  text-align: center;
  color: white;
  height: 30rem;
  overflow: hidden;
}

.modal-banner-text {
  font-size: 3vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

.itinerary-container {
  border: 1px solid black;
  margin-top: 10px;
  padding: 10px;
}

.inclusion-container {
  background-color: #dbdbdb;
  margin: 10px;
  padding: 10px;
}

.address {
  text-indent: 40px;
}

.image-size {
  height: 40vh;
}

.vtd-center-image {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
}

.vtd-font-weight-bold {
  font-weight: bolder;
}

.orange {
  color: orange;
  font-weight: bolder;
}
</style>
